



































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { LeaversService } from '@/services/LeaversTool/LeaversService';
import { LeaverModel, LeaverDocumentModel, LeaverDocumentStatus } from '@/types';
import { EnumHelper } from '@/mixins/enumHelper';

export default Vue.extend({
  name: 'LeaverHistoryLog',
  props: {
    leaverId: {
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      pageIsLoading: false,
      leaver: {
        documents: [] as LeaverDocumentModel[]
      } as LeaverModel,
      statusId: -1,
      fields: [
        {
          key: 'documentId',
          label: 'Document ID',
          sortable: true
        },
        {
          key: 'fromCabinet.description',
          label: 'From Cabinet',
          sortable: true
        },
        {
          key: 'fromDocumentType.description',
          label: 'From Document Type',
          sortable: true
        },
        {
          key: 'toCabinet.description',
          label: 'To Cabinet',
          sortable: true
        },
        {
          key: 'toDocumentType.description',
          label: 'To Document Type',
          sortable: true
        },
        {
          key: 'retentionDateSet',
          label: 'Retention Date',
          formatter: 'date',
          sortable: true
        },
        {
          key: 'status',
          label: 'Status',
          formatter: (value: any) => {
            return LeaverDocumentStatus[value];
          },
          sortable: true
        },
        {
          key: 'errorMessage',
          label: 'Error Message'
        }
      ]
    };
  },
  methods: {
    async getLeaverAsync(this: any) {
      this.isLoading = true;
      await LeaversService.getAsync(this.leaverId).then((result: LeaverModel) => {
        this.leaver = result;
        this.isLoading = false;
      });
    }
  },
  computed: {
    statusDropdownOptions(this: any) {
      const statuses = EnumHelper.methods.convertNumberBasedEnumToArray(LeaverDocumentStatus);
      statuses.push({ key: -1, value: 'All' });
      return statuses;
    },
    showLeaverDocuments(this: any): LeaverDocumentModel[] {
      let filteredLeaverDocuments = this.leaver.documents;
      if (this.leaver.documents.length > 0 && this.statusId > -1) {
        filteredLeaverDocuments = filteredLeaverDocuments.filter(
          (x: LeaverDocumentModel) => x.status === this.statusId
        );
      }
      filteredLeaverDocuments.forEach((leaverDocument: any) => {
        if (leaverDocument.status === LeaverDocumentStatus.Pending) {
          leaverDocument._cellVariants = { status: 'info' };
        } else if (leaverDocument.status === LeaverDocumentStatus.Success) {
          leaverDocument._cellVariants = { status: 'success' };
        } else if (leaverDocument.status === LeaverDocumentStatus.Failed) {
          leaverDocument._cellVariants = { status: 'danger' };
        }
      });
      return filteredLeaverDocuments;
    }
  },
  async mounted() {
    this.pageIsLoading = true;
    await this.getLeaverAsync();
    this.pageIsLoading = false;
  },
  components: {
    MStoreTable,
    MStoreFormSelect,
    LoadingSpinner
  }
});
